import { API_ROOT, getAccessToken, refreshBrowserSession } from '@/auth/auth-session';

export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  let token = getAccessToken();
  if (!token) token = (await refreshBrowserSession())?.accessToken ?? null;
  let response = await fetch(`${API_ROOT}/api${path}`, {
    ...init,
    credentials: 'include',
    headers: {
      ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...init?.headers,
    },
  });
  if (response.status === 401) {
    const refreshed = await refreshBrowserSession();
    if (refreshed) {
      response = await fetch(`${API_ROOT}/api${path}`, {
        ...init,
        credentials: 'include',
        headers: {
          ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
          Authorization: `Bearer ${refreshed.accessToken}`,
          ...init?.headers,
        },
      });
    }
    if (response.status === 401) {
      window.dispatchEvent(new Event('futsaly-auth-expired'));
      throw new ApiError(401, 'Session expired');
    }
  }
  if (!response.ok) {
    const contentType = response.headers.get('content-type') ?? '';
    const payload = contentType.includes('application/json')
      ? await response.json().catch(() => ({})) as { message?: string; error?: string }
      : {};
    const fallback = response.status === 404
      ? 'The requested API route is not available. Restart the API with the latest code.'
      : `Request failed with status ${response.status}`;
    throw new ApiError(response.status, payload.message ?? payload.error ?? fallback);
  }
  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
}
